import Assets from "./Assets/Assets";
import AssetsCategory from "./Assets/AssetsCategory";
import AssetConditions from "./Assets/Settings/AssetConditions";
import AssetNumberSeries from "./Assets/Settings/AssetNumberSeries";
import AssetRequestSettings from "./Assets/Settings/AssetRequestSettings";
import AssetUnavailableStatus from "./Assets/Settings/AssetUnavailableStatus";
import FormCategory from "./Doccumets/FormBuilder";
import Forms from "./Doccumets/FormBuilder/Forms";
import DoccumentSettings from "./Doccumets/Settings";
import Billable from "./Employees/EmployeeDirectory/Billable";
import OnBench from "./Employees/EmployeeDirectory/OnBench";
import JobTitles from "./Employees/Settings/JobTitles";
import Quarters from "./Employees/Settings/QuarterSettings";
import Employee from "./Employees/Probation/ProbationFeedbackForm/Employee";
import Reviewer from "./Employees/Probation/ProbationFeedbackForm/Reviewer";


export default {
    Billable,
    OnBench,
    DoccumentSettings,
    FormCategory,
    Forms,
    AssetsCategory,
    Assets,
    AssetNumberSeries,
    AssetConditions,
    AssetUnavailableStatus,
    AssetRequestSettings,
    JobTitles,
    Quarters,
    Reviewer,
    Employee
}